import React, { useEffect, useState } from 'react'
import { Col, NavDropdown, Row } from 'react-bootstrap'
import Dropdown from 'react-bootstrap/Dropdown'
import { FaCommentDots } from 'react-icons/fa'
import AboutUsIcon from '../../../icons/about-us-icon'
import CellPhoneIcon from '../../../icons/cellphone'
import ChatIcon from '../../../icons/chat'
import MailIcon from '../../../icons/mail'
import PhoneIcon from '../../../icons/phone'
import ChatButton from '../../buttons/chat-button/ChatButton'
import { dropDown, phoneIcon } from '../Header/header.module.scss'
import { menuData } from './menu-data'

function DropdownIcon() {
  return (
    <Dropdown className={dropDown}>
      <Dropdown.Toggle variant='success' id='dropdown-basic'>
        <PhoneIcon className={phoneIcon} />
      </Dropdown.Toggle>

      <Dropdown.Menu>
        <Dropdown.Item href='tel:1-800-936-1287'>
          <CellPhoneIcon />
          1-800-936-1287
        </Dropdown.Item>
        <Dropdown.Item>
          <ChatIcon />
          <ChatButton customClass='open-chat-icon'>Open Live Chat</ChatButton>
        </Dropdown.Item>
        <Dropdown.Item href='mailto:info@rubberflooring4u.com'>
          <MailIcon />
          info@rubberflooring4u.com
        </Dropdown.Item>
      </Dropdown.Menu>
    </Dropdown>
  )
}

function DropdownMenu() {
  const [hovered, setHovered] = useState(false)

  return (
    <React.Fragment>
      {menuData.map((item, index) => {
        return (
          <Row className='dropdown-wrapper'>
            <Col lg={4}>
              <NavDropdown.Item
                onMouseOver={() => {
                  setHovered(true)
                }}
              >
                {item.menuName}
              </NavDropdown.Item>
            </Col>
            <Col lg={4}>
              <ul className={hovered ? 'd-block' : 'd-none'}>
                {item.subitems.map((subitem, index) => {
                  return <li>{subitem.name}</li>
                })}
              </ul>
            </Col>
            <Col lg={4}>
              <img src='https://via.placeholder.com/200X400' />
            </Col>
          </Row>
        )
      })}
    </React.Fragment>
  )
}

export { DropdownIcon, DropdownMenu }
